import { AjaxGetAndReplaceHtml } from "../../shared/ajaxGetAndReplaceHtml";
import { IInstanceComponentBase, InstanceComponentBase } from "../../shared/instanceComponentBase";
import { AttributeEnums } from "../../shared/utilities/enums/attributeEnums";
import { UrlEnums } from "../../shared/utilities/enums/urlEnums";
import { HelperUtils } from "../../shared/utilities/helperUtils";
import { ISearchBase, SearchBase } from "./searchBase";
import { ISearchPages, SearchPages } from "./searchPages";
import { ISearchProducts, SearchProducts } from "./searchProducts";

const urlPaths = require('../../config/urlPaths.json');

export interface ISearch extends ISearchBase {

}

export class Search extends SearchBase implements ISearch {
    private searchPages: ISearchPages;
    private searchProducts: ISearchProducts;
    private readonly _handleSearchKeyPress;
    private readonly _handleClearButtonClicked;

    constructor(htmlElement: Element) {
        super(htmlElement);
        //----- Event Listener Bindings Start -----//
        this._handleSearchKeyPress = this.handleSearchKeyPress.bind(this);
        this._handleClearButtonClicked = this.handleClearButtonClicked.bind(this);
        //----- Event Listener Bindings End -----//

        this.searchPagesAndProductsFactory();

        //----- Initialise Event Listeners Start -----//

        this.attachValueOnKeyUpEventToSearchInput();
        this.attachClearButtonClickEventToSearchInput();
        //----- Initialise Event Listeners End -----//
        this.checkClearSearchShowHide();
    }
    disposeOfPagesAndProducts(): void {
        if (this.searchPages) {
            this.searchPages.dispose();
            this.searchPages = null;
        }
        if (this.searchProducts) {
            this.searchProducts.dispose();
            this.searchProducts = null;
        }
    }
    reinitialisePagesAndProducts(): void {
        this.disposeOfPagesAndProducts();
        this.searchPagesAndProductsFactory();
    }
    searchPagesAndProductsFactory(): void {
        try {
            let searchPagesElemet: HTMLElement = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.SearchPages.SearchPages));
            if (searchPagesElemet) {
                this.searchPages = new SearchPages(searchPagesElemet);
            }
            let searchProductsElemet: HTMLElement = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.SearchProducts.SearchProducts));
            if (searchProductsElemet) {
                this.searchProducts = new SearchProducts(searchProductsElemet);
            }
        } catch (error) {
            console.log('Search: searchPagesAndProductsFactory ERROR', error);
        }
    }

    //------ Event Listeners Start -----//
    async attachValueOnKeyUpEventToSearchInput() {
        let inputElement = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.Search.Input));
        inputElement.addEventListener('keyup', this._handleSearchKeyPress);
    }

    async removeValueOnKeyUpEventFromSearchInput() {
        let inputElement = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.Search.Input));
        inputElement.removeEventListener('keyup', this._handleSearchKeyPress);
    }

    async attachClearButtonClickEventToSearchInput() {
        let clearButtonElement = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.Search.ClearButton));
        clearButtonElement.addEventListener('click', this._handleClearButtonClicked);
    }

    async removeClearButtonClickFromSearchInput() {
        let clearButtonElement = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.Search.ClearButton));
        clearButtonElement.removeEventListener('click', this._handleClearButtonClicked);
    }
    //------ Event Listeners End -----//
    //------ Event Listener Methods Start -----//
    async handleSearchKeyPress(event: Event): Promise<void> {
        console.log('Search: setValueWithEvent - Beginning');

        const element = event.target as HTMLInputElement;

        if (element.hasAttribute(AttributeEnums.Search.Input)) {
            let searchTerm: string = element.value.toLowerCase();
            if (searchTerm.length > 0) {
                await this.getSearch(searchTerm);
                this.showClearButton();
            } else {
                await this.getTrendingSearches();
                this.hideClearButton();
            }
            this.reinitialisePagesAndProducts();
        }
    }

    checkClearSearchShowHide() {
        try {
            let inputElement = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.Search.Input)) as HTMLInputElement;
            if (inputElement.value.length === 0) {
                this.hideClearButton();
            } else {
                this.showClearButton();
            }
        } catch (error) {
            console.log("Search: initialiseClearSearchShowHide Error handling clear button initialise", error);
        }
    }
    async handleClearButtonClicked(event: Event): Promise<void> {
        console.log("Search: handleClearButtonClicked");
        try {
            let inputElement = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.Search.Input)) as HTMLInputElement;
            inputElement.value = '';
            await this.getTrendingSearches();
            this.hideClearButton();
            this.setFocusToInput();
            this.disposeOfPagesAndProducts();
        } catch (error) {
            console.log("Search: handleClearButtonClicked Error handling clear button click", error);
        }
    }
    //------ Event Listener Methods End -----//
    showClearButton() {
        try {
            console.log("Search: showClearButton");
            let clearButtonElement = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.Search.ClearButton));
            clearButtonElement.classList.remove('lb_searchBox_clear-hidden');
        } catch (error) {
            console.log("Search: showClearButton Error", error);
        }
    }

    hideClearButton() {
        try {
            console.log("Search: hideClearButton");
            let clearButtonElement = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.Search.ClearButton));
            clearButtonElement.classList.add('lb_searchBox_clear-hidden');
        } catch (error) {
            console.log("Search: hideClearButton Error", error);
        }
    }
    setFocusToInput() {
        console.log("Search: setFocusToInput");
        try {
            let inputElement = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.Search.Input)) as HTMLInputElement;
            inputElement.focus();
        } catch (error) {
            console.log("Search: setFocusToInput Error ", error);
        }
    }

    dispose(): void {
        console.log('Search: dispose');
        this.removeValueOnKeyUpEventFromSearchInput();
        this.removeClearButtonClickFromSearchInput();
    }

}